import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { MEMBER_ACCESS_TOKEN } from 'utils/storageKeys';

const basicConfig: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
};

const publicConfig: AxiosRequestConfig = {
  baseURL: process.env?.REACT_APP_PUBLIC_API_URL || process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
};

export const setCommunityId = (communityId: string | number) => {
  axiosApi.defaults.headers.common['communityid'] = communityId;
  publicAxiosApi.defaults.headers.common['communityid'] = communityId;
};

const axiosApi = axios.create(basicConfig);
const publicAxiosApi = axios.create(publicConfig);

// Interceptors
axiosApi.interceptors.request.use(
  function (config: AxiosRequestConfig) {
    const accessToken = localStorage.getItem(MEMBER_ACCESS_TOKEN);

    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`,
        communityid: process.env.REACT_APP_COMMUNITY_ID,
      },
    };
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosApi.interceptors.response.use(
  function (response: AxiosResponse) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

// Add response interceptor
publicAxiosApi.interceptors.response.use(
  function (response: AxiosResponse) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export default axiosApi;

export { publicAxiosApi };
